import React from 'react';
import { Container, Section } from '../components/ui/Section';
import { ButtonExternal } from '../components/ui/Button';
import { Reveal } from '../components/motion/Reveal';
import { DoodleUnderline } from '../components/brand/Doodles';
import { DoodleScatter } from '../components/brand/DoodleScatter';
import { externalLinks } from '../data/site';
export function Photos() {
  return <Section className="bcm-paper relative overflow-hidden py-16 sm:py-24" labelledBy="photos-heading" data-id="element-585" data-mp="27trr70j8quv3">
      {/* Content hugs the left, so the whole right side is free for shapes. */}
      <DoodleScatter tone="paper" seed="photos-page" layout="leftColumn" data-id="element-586" data-mp="1yt3k6ps9lurp" />
      <Container className="relative" data-id="element-587" data-mp="1yv69f7llfjvd">
        <Reveal className="max-w-xl" data-id="element-588" data-mp="23r54fe1fg04r">
          <p className="font-meta text-xs font-semibold uppercase tracking-[0.18em] text-brand-navy" data-id="element-589" data-mp="23q3j8gqp5x9b">
            Life at BCM
          </p>
          <h1 id="photos-heading" className="mt-3 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-brand-navy sm:text-6xl" data-id="element-590" data-mp="schwf28b87qy">
            Photos
          </h1>
          <DoodleUnderline className="mt-3 h-3.5 w-36" color="var(--bcm-dark-blue)" data-id="element-591" data-mp="25mtzydlfg68u" />
          <p className="mt-6 font-sans text-[17px] leading-relaxed text-ink sm:text-lg" data-id="element-592" data-mp="2kjugrm22ygsj">
            Photos will be updated weekly throughout the school year.
          </p>
          <div className="mt-8" data-id="element-593" data-mp="2fmktod25yh7v">
            <ButtonExternal href={externalLinks.photoAlbum} className="min-h-[56px] px-8 py-4 text-[17px] sm:text-lg" data-id="element-594" data-mp="2tjhmgk1ue8re">
              Open BCM Photo Album
            </ButtonExternal>
          </div>
        </Reveal>
      </Container>
    </Section>;
}